import get from 'lodash.get';
import {
    DEFAULT_FLOW,
    REGISTER,
    LOGIN,
    REQUEST_PASSWORD_EMAIL,
    RESET_PASSWORD,
    UPDATE_PASSWORD,
    SOCIAL_ACCOUNT_LINKED,
} from './authFlowConstants';
import {
    LAUNCH_LOGIN_MODAL,
    LAUNCH_REGISTRATION_MODAL,
    LAUNCH_REQUEST_PASSWORD_EMAIL,
    LAUNCH_RESET_PASSWORD,
    LAUNCH_UPDATE_PASSWORD,
    LAUNCH_SOCIAL_ACCOUNT_LINKED,
    NEXT_STEP,
    AUTHENTICATION_ERROR,
    CLOSE_MODAL,
    SET_CLOSE_BUTTON_COLOR,
    SET_AUTH_RESPONSE,
    SAVE_AUTH_STATE,
    UPDATE_AUTH,
} from './authActions';

export function getInitialState() {
    return {
        email: '',
        fireEntryGa: true,
        flow: DEFAULT_FLOW,
        ga: {},
        modal: '',
        resolve() {}, // in case you need a callback after the auth process is done
        serverError: '',
        showExistsError: false,
        step: 0,
        additionalProps: {},
        authResponse: {},
        shouldPauseAuthFlow: () => false,
        isPaused: false,
        savedState: {},
        isContentOnly: false,
        closeButtonColor: null,
    };
}

export default function authReducer(state = getInitialState(), action) {
    const { payload = {}, type } = action;
    const {
        email = state.email,
        fireEntryGa = true,
        flow = state.flow,
        ga = state.ga,
        resolve = state.resolve,
        serverError = '',
        showExistsError = false,
        step = 0,
        additionalProps = state.additionalProps,
        closeButtonColor = state.closeButtonColor,
        authResponse = state.authResponse,
        shouldPauseAuthFlow = state.shouldPauseAuthFlow,
        isPaused = state.isPaused,
        isContentOnly = state.isContentOnly,
    } = payload;

    switch (type) {
        case LAUNCH_LOGIN_MODAL:
            return {
                ...state,
                email,
                fireEntryGa,
                flow,
                ga,
                additionalProps,
                modal: LOGIN,
                resolve,
                showExistsError,
                serverError,
                isPaused,
                shouldPauseAuthFlow,
                isContentOnly,
                authResponse,
            };
        case LAUNCH_REGISTRATION_MODAL:
            return {
                ...state,
                email,
                fireEntryGa,
                flow,
                ga,
                additionalProps,
                modal: REGISTER,
                resolve,
                serverError,
                step,
                isPaused,
                shouldPauseAuthFlow,
                isContentOnly,
                authResponse,
            };
        case LAUNCH_REQUEST_PASSWORD_EMAIL:
            return {
                ...state,
                email,
                flow,
                ga,
                fireEntryGa,
                additionalProps,
                modal: REQUEST_PASSWORD_EMAIL,
                serverError,
                step,
                isPaused,
                shouldPauseAuthFlow,
                isContentOnly,
                authResponse,
            };
        case LAUNCH_RESET_PASSWORD:
            return {
                ...state,
                flow,
                fireEntryGa,
                ga,
                modal: RESET_PASSWORD,
                resolve,
                serverError,
                isContentOnly,
                authResponse,
            };
        case LAUNCH_UPDATE_PASSWORD:
            return {
                ...state,
                fireEntryGa,
                email,
                ga,
                modal: UPDATE_PASSWORD,
                serverError,
                isContentOnly,
                authResponse,
            };
        case LAUNCH_SOCIAL_ACCOUNT_LINKED:
            return { ...state, modal: SOCIAL_ACCOUNT_LINKED, isContentOnly };
        case NEXT_STEP:
            return { ...state, email, step: step + 1, additionalProps, serverError };
        case AUTHENTICATION_ERROR:
            return { ...state, serverError };
        case SET_CLOSE_BUTTON_COLOR:
            return { ...state, closeButtonColor };
        case SET_AUTH_RESPONSE:
            return { ...state, authResponse, email: get(authResponse, 'user.profile.email') };
        case CLOSE_MODAL:
            return { ...getInitialState(), isPaused, savedState: state };
        case SAVE_AUTH_STATE:
            return { ...state, isPaused, savedState: state };
        case UPDATE_AUTH:
            return { ...state, ...payload };
        default:
            return state;
    }
}
